const ListingCardSkeleton = () => {
  return (
    <div className="relative bg-white">
      <div className="h-[165px] w-full animate-pulse rounded-[8px] bg-gray-200 object-cover" />
      <div className="flex flex-col gap-1 py-3">
        <div className="h-6 w-32 animate-pulse rounded bg-gray-200" />
        <div className="h-4 w-24 animate-pulse rounded bg-gray-200" />
        <div className="h-4 w-40 animate-pulse rounded bg-gray-200" />
        <div className="h-4 w-28 animate-pulse rounded bg-gray-200" />
      </div>
      <div className="absolute left-3 top-3">
        <div
          className="h-6 w-10 animate-pulse rounded bg-gray-300 px-2 py-1"
          style={{ background: 'rgba(27, 48, 41, 0.75)', backdropFilter: 'blur(1px)' }}
        />
      </div>
    </div>
  )
}

export default ListingCardSkeleton
